import { ArrowUturnLeftIcon } from "@heroicons/react/24/outline";

import { DropdownMenuItem } from "@fronterahealth/frontera-ui-components/ui/dropdown-menu";

import { ReportReviewerStatus } from "@api/graphql/types-and-hooks";
import { useCanWithdrawReview } from "@components/ReportReview/hooks/useCanReviewReport";
import { useReviewStatus } from "@components/ReportReview/hooks/useReviewStatus";

export const WithdrawDecisionMenuItem: React.FC = () => {
  const { setStatus } = useReviewStatus();
  const can = useCanWithdrawReview();

  return (
    <DropdownMenuItem
      disabled={!can}
      onClick={() => void setStatus(ReportReviewerStatus.Requested).catch(() => undefined)}
    >
      <ArrowUturnLeftIcon />
      Withdraw decision
    </DropdownMenuItem>
  );
};
